@if (loadingBar.value$ | async) {
    <div class="loader-overlay"></div>
}
<ngx-loading-bar height="4px" class="ngx-loading-bar"></ngx-loading-bar>

@if (isLoginPage()) {
    <!-- Layout simples para login (sem sidebar/header) -->
    <router-outlet></router-outlet>
} @else {
    <!-- Layout completo com sidebar e header -->
    <div class="app-container">
        <!-- Overlay para mobile -->
        <div class="sidebar-overlay"
             [class.active]="!sidebarCollapsed()"
             (click)="toggleSidebar()"></div>

        <app-sidebar
                [class.collapsed]="sidebarCollapsed()"
                [collapsed]="sidebarCollapsed()"
                (closeSidebar)="closeSidebar()"/>

        <div class="main-wrapper">
            <header class="top-bar">
                <div class="d-flex align-items-center">
                    <button class="menu-toggle" (click)="toggleSidebar()" aria-label="Toggle menu">
                        <i class="ti ti-menu-2"></i>
                    </button>
                </div>
            </header>

            <main class="view-content">
                <router-outlet></router-outlet>
            </main>
        </div>
    </div>
}

